import { dspAssetUrl } from '../audio/dspAssetUrl';
let worker;
let sequence=0;
const jobs=new Map();
const compiled=new Map();
export function toneTableKey(table) {
  const text=JSON.stringify(table.frames);let hash=2166136261;
  for(let i=0;i<text.length;i++)hash=Math.imul(hash^text.charCodeAt(i),16777619);
  return `table-${(hash>>>0).toString(16)}-${text.length}`;
}
function ensureCompiler() {
  if(typeof Worker!=='function')throw new Error('Tone compiler worker unavailable');
  if(!worker) {
    worker=new Worker(dspAssetUrl('/audio/wavetableCompilerWorker.js'));
    worker.onmessage=({data})=>{ const job=jobs.get(data.id);if(!job)return;jobs.delete(data.id);data.error?job.reject(new Error(data.error)):job.resolve({key:job.key,frames:data.frames,samples:data.samples,sampleRate:data.sampleRate}); };
    worker.onerror=()=>{jobs.forEach(job=>job.reject(new Error('Tone compiler failed')));jobs.clear();worker.terminate();worker=null;};
  }
}
export function compileToneTable(table) {
  const key=toneTableKey(table);
  if(compiled.has(key))return compiled.get(key);
  const promise=new Promise((resolve,reject)=>{
    ensureCompiler();
    const id=++sequence;jobs.set(id,{resolve,reject,key});worker.postMessage({id,table});
  });
  compiled.set(key,promise);
  promise.catch(()=>compiled.delete(key));
  if(compiled.size>32)compiled.delete(compiled.keys().next().value);
  return promise;
}

export function compileToneSample(buffer,key) {
  try { ensureCompiler(); } catch(error) { return Promise.reject(error); }
  const promise=new Promise((resolve,reject)=>{
    const id=++sequence;jobs.set(id,{resolve,reject,key});
    const channels=Array.from({length:buffer.numberOfChannels},(_,i)=>buffer.getChannelData(i));
    worker.postMessage({id,kind:'sample',channels,sampleRate:buffer.sampleRate});
  });
  return promise;
}
